const mountBaseUrl = () => {
  const env = process.env.NODE_ENV;
  if (env === 'development') {
    return 'http://localhost:8002/api';
  }
  return 'https://acta.publisol.com.br/api';
};

export function getActaRelativeFileUrl(url?: string): string {
  const baseURL = mountBaseUrl();
  if (!url) {
    return '';
  }
  // Se o backend já retornar um "http://..." completo, não precisa concatenar
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // Caso contrário, concatena com a baseURL
  return `${baseURL}${url}`;
}
